(function () {
  'use strict';

  var STORAGE_KEY = 'catchy_newsletter_seen';
  var popup = document.getElementById('newsletter-popup');
  var closeBtn = document.getElementById('newsletter-popup-close');
  var skipBtn = document.getElementById('newsletter-popup-skip');

  function shouldShow() {
    try { return !localStorage.getItem(STORAGE_KEY); }
    catch (e) { return false; }
  }

  function dismiss() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    closePopup();
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openPopup() {
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }

  if (popup && shouldShow()) {
    var delay = (window.CATCHY && window.CATCHY.newsletterDelay) || 5000;
    var timer = setTimeout(function () {
      // Don't show if cart or search is open
      if (document.querySelector('.cart-drawer.is-open') || document.querySelector('.search-drawer.is-open')) return;
      openPopup();
    }, delay);

    closeBtn && closeBtn.addEventListener('click', dismiss);
    skipBtn && skipBtn.addEventListener('click', dismiss);

    // Close on backdrop click
    popup.addEventListener('click', function (e) {
      if (e.target === popup) dismiss();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
    });

    // Handle form success
    var form = document.getElementById('newsletter-popup-form');
    if (form) {
      form.addEventListener('submit', function () {
        setTimeout(dismiss, 3000);
      });
    }
  }

  // Exit intent popup
  var exitIntent = document.getElementById('exit-intent');
  var exitClose = document.getElementById('exit-intent-close');
  var exitSkip = document.getElementById('exit-intent-skip');
  var exitShown = false;

  function showExitIntent() {
    if (exitShown || !exitIntent) return;
    try { if (localStorage.getItem('catchy_exit_seen')) return; } catch (e) {}
    exitShown = true;
    exitIntent.classList.add('is-open');
    exitIntent.setAttribute('aria-hidden', 'false');
  }

  function dismissExit() {
    try { localStorage.setItem('catchy_exit_seen', '1'); } catch (e) {}
    if (exitIntent) {
      exitIntent.classList.remove('is-open');
      exitIntent.setAttribute('aria-hidden', 'true');
    }
  }

  exitClose && exitClose.addEventListener('click', dismissExit);
  exitSkip && exitSkip.addEventListener('click', dismissExit);

  if (exitIntent) {
    exitIntent.addEventListener('click', function (e) {
      if (e.target === exitIntent) dismissExit();
    });
  }

  // Desktop: mouse leaves top of page
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 0) showExitIntent();
  });

  // Mobile: show after 30s of scrolling + user scrolls back up fast
  if ('ontouchstart' in window) {
    var lastScrollTop = 0;
    var scrollTimer;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var currentScroll = window.scrollY;
        // User scrolled up fast (more than 200px) = trying to leave
        if (lastScrollTop - currentScroll > 200 && currentScroll > 100) {
          showExitIntent();
        }
        lastScrollTop = currentScroll;
      }, 150);
    }, { passive: true });

    // Also show after 45 seconds of being on the page (idle)
    setTimeout(function () {
      showExitIntent();
    }, 45000);
  }

  var exitForm = document.getElementById('exit-intent-form');
  if (exitForm) {
    exitForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = exitForm.querySelector('input[type="email"]');
      if (input && input.value) {
        // Subscribe via Shopify customer endpoint
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&contact[email]=' + encodeURIComponent(input.value) + '&contact[tags]=exit-intent'
        }).finally(function () {
          exitForm.innerHTML = '<p style="color:var(--c-gold);font-size:0.9375rem;">✓ Your discount code has been sent!</p>';
          setTimeout(dismissExit, 3000);
        });
      }
    });
  }
})();
